const withdraw = {
  draw_bank_account: '银行账户',
  draw_bank_name: '银行名称',
  draw_beneficiary: '收款人姓名',
  draw_swift: '身份证号码/ SWIFT代码',
  draw_receving: '接收银行信息',
  draw_corres: '输入值',
  draw_bank_address: '银行地址',
  draw_add_1: '地址行1',
  draw_add_2: '地址行2',
  draw_country: '国家',
  draw_city: '城市',
  draw_post_code: '邮政编码',
  draw_intermediary: '这家银行需要中介',
  draw_inter_name: '中介银行名称',
  draw_add_info: '附加信息',
  isRequired: '这是必填栏',
  least_fifteen: '至少4',

}
export default withdraw;


// WEBPACK FOOTER //
// ./src/i18n/chinese/withdraw.js